/** BEM класе за приказ једног обавештења — header dropdown и dashboard. */

export const NOTIFICATION_ITEM_UI = {
  header: {
    item: 'header-notifications-dropdown-item',
    inner: 'header-notifications-dropdown-item-inner',
    head: 'header-notifications-dropdown-item-head',
    type: 'header-notifications-dropdown-item-type',
    body: 'header-notifications-dropdown-item-body',
    trigger: 'notification-trigger-hint header-notifications-dropdown-item-trigger',
    context: 'header-notifications-dropdown-item-context',
    links: 'header-notifications-dropdown-item-links',
    linksSep: 'header-notifications-dropdown-item-links-sep',
    link: 'header-notifications-dropdown-item-link',
    actionsTop: 'header-notifications-dropdown-item-actions-top',
    actionsToolbar: 'header-notifications-dropdown-item-actions-top-toolbar',
    actionsCta: 'header-notifications-dropdown-item-actions-cta',
    linkBtn: 'header-notifications-dropdown-link-btn',
    linkBtnLabel: 'header-notifications-dropdown-link-btn-label',
    linkBtnMeta: 'header-notifications-dropdown-link-btn-meta',
    linkBtnIcon: 'header-notifications-dropdown-link-btn-icon',
    actionsModerator: 'header-notifications-btn-group header-notifications-dropdown-item-actions--moderator',
    cmd: 'header-notifications-dropdown-cmd',
    cmdAccept: 'header-notifications-dropdown-cmd header-notifications-dropdown-cmd--accept',
    cmdReject: 'header-notifications-dropdown-cmd header-notifications-dropdown-cmd--reject',
    markReadWrap: 'header-notifications-dropdown-item-mark-read',
    markReadBtn: 'header-notifications-dropdown-mark-read-btn',
    markReadIcon: 'header-notifications-dropdown-mark-read-btn-icon',
    markReadText: 'header-notifications-dropdown-mark-read-btn-text',
  },
  dashboard: {
    item: 'dashboard-notification-item',
    inner: 'dashboard-notification-item-inner',
    head: 'dashboard-notification-item-head',
    headMain: 'dashboard-notification-item-head-main',
    headEnd: 'dashboard-notification-item-head-end',
    type: 'dashboard-notification-item-type',
    time: 'dashboard-notification-time',
    markReadBtnHead: 'dashboard-notification-mark-read-btn--head',
    body: 'dashboard-notification-item-body',
    trigger: 'notification-trigger-hint dashboard-notification-item-trigger',
    context: 'dashboard-notification-item-text',
    links: 'dashboard-notification-item-links',
    linksSep: 'dashboard-notification-item-links-sep',
    link: 'dashboard-notification-item-link',
    actionsToolbar: 'dashboard-notification-item-toolbar',
    actionsModerator: 'dashboard-notification-btn-group dashboard-notification-item-actions--moderator',
    cmd: 'dashboard-notification-cmd',
    cmdAccept: 'dashboard-notification-cmd dashboard-notification-cmd--accept',
    cmdReject: 'dashboard-notification-cmd dashboard-notification-cmd--reject',
    actionsBar: 'dashboard-notification-item-actions-bar',
    actionsTop: 'dashboard-notification-item-actions-top',
    actionsCta: 'dashboard-notification-item-actions-cta',
    markReadWrap: 'dashboard-notification-item-mark-read',
    linkBtn: 'dashboard-notification-link-btn',
    markReadBtn: 'dashboard-notification-mark-read-btn',
    markReadIcon: 'dashboard-notification-mark-read-btn-icon',
    markReadText: 'dashboard-notification-mark-read-btn-text',
  },
};
